export default __webpack_public_path__ + "static/Tek_Double_Doorframe-6bef7cf1011848ac9e385ad494af9ae0.png";